<template>
	<div>
		<div @click="selectApp" ref="app_container" class="app-container px-5 py-1 width-100" :class="{ 'on-focus': isFocused }">
			<div
				:class="{ 'explanation-mode': !useSeenInterfaceExplanation }"
				class="app-card-container flex-centerize flex-column width-100 height-100"
			>
				<SIcon :width="30" :height="30" :name="icon" />
				<div class="app-title mt-1">Interface</div>
				<div class="app-description">Add a custom user-facing step</div>
			</div>
		</div>
		<InterfaceMenuItemExplanation v-if="!useSeenInterfaceExplanation" class="explanation-container" />
	</div>
</template>

<script>
import AppService from '@/utils/AppService';
import { mapGettersShorthand } from '@/store/utils/mappers';
import InterfaceMenuItemExplanation from './InterfaceMenuItemExplanation.vue';
import { useSeenInterfaceExplanation } from '@/store/modules/appLayout/getters.js';
export default {
	name: 'InterfaceMenuItem',
	components: { InterfaceMenuItemExplanation },
	props: {
		app: { type: Object },
		focusedItemUUID: { type: String },
	},
	computed: {
		...mapGettersShorthand({ useSeenInterfaceExplanation }),
		isFocused() {
			const uuid = AppService.getUniqueId(this.app.type, this.app.id, this.app.service_name);
			return this.focusedItemUUID === uuid;
		},
		icon() {
			if (this.app.overrideIcon) {
				return this.app.overrideIcon;
			}
			return this.app.service_slug;
		},
	},
	methods: {
		selectApp() {
			this.$emit('app-selected', this.app);
		},
		onKeyDown(event) {
			if (this.isFocused) {
				if (event.keyCode === 13) {
					this.selectApp();
				}
			}
		},
		removeOnKeyDownListener() {
			if (this.onKeyDownHandler) {
				window.removeEventListener('keydown', this.onKeyDownHandler, true);
				this.onKeyDownHandler = null;
			}
		},
		listenOnKeyDown() {
			this.removeOnKeyDownListener();
			this.onKeyDownHandler = (e) => this.onKeyDown(e);
			window.addEventListener('keydown', this.onKeyDownHandler, true);
		},
	},
	mounted() {
		this.listenOnKeyDown();
	},
	watch: {
		isFocused: {
			handler(newV) {
				newV && this.$emit('scroll-to-element', this.$refs.app_container.getBoundingClientRect().y - 400);
			},
		},
	},
	data: () => ({ onKeyDownHandler: null }),
	beforeDestroy() {
		this.removeOnKeyDownListener();
	},
};
</script>

<style scoped lang="scss">
$side-padding: 20px;
.on-focus {
	.app-card-container {
		background-color: var(--app-selection-hover-background);
	}
}
$item-height: 140px;
.app-container {
	height: $item-height;
	cursor: pointer;
	margin-top: 6px;
	&:hover {
		.app-card-container {
			background-color: var(--app-selection-hover-background);
		}
	}
	.app-title {
		font-size: 14px;
		color: var(--bold-title);
	}
	.app-description {
		font-size: 11px;
		color: var(--description-text);
	}
}
.app-card-container {
	border-radius: 10px;
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);
	&.explanation-mode {
		border: 0.5px solid rgb(91, 91, 231);
		box-shadow: 0px 3px 6px rgba(91, 91, 231, 0.3);
	}
}

.explanation-container {
	$explanation-width: 290px;
	$explanation-height: 400px;

	position: fixed;
	width: $explanation-width;
	height: $explanation-height;
	margin-top: calc(4px - #{$item-height});
	margin-left: calc(10px - #{$explanation-width});
}
</style>
